import React from "react";
import { Link } from "react-router-dom";
import "./JoinUsPage.css";
import { useVolunteerSection } from "../hooks/useVolunteerSection";
import { useCompanyDetails } from "../hooks/useCompanyDetails";
import { buildMailtoLink } from "../utils/companyContact";

import team from "../assets/images/membership/team.avif";
import volunteer from "../assets/images/membership/volunteer.jpg";
import internship from "../assets/images/membership/internship.jpg";
import Hero from "../components/Hero";
import {
  MemberText,
  InternText,
  DEFAULT_VOLUNTEER_TEXT,
} from "../utils/joinUsPage.helpers";

const JoinUsPage: React.FC = () => {
  const { data: volunteerSection } = useVolunteerSection();
  const { data: companyDetails } = useCompanyDetails();
  const volunteerText =
    volunteerSection?.sectionText?.trim() || DEFAULT_VOLUNTEER_TEXT;
  const volunteerMailto = buildMailtoLink(
    companyDetails?.companyEmailAddress,
    "I want to volunteer!",
  );

  return (
    <>
      <Hero page={"join-us"} titleTwo={"Join The Project!"} />

      <div className="hero-introduction-wrapper join-us-extra-space">
        <div className="hero-introduction-container">
          <div className="hero-introduction">
            <p>
              There are many ways to get involved with Alnarp’s Farm and we are
              always open to new people joining the project! One of the great
              pleasures of this farm is that it is made up of wonderful,
              motivated and passionate individuals who want to learn about
              growing food in a better way.
            </p>
          </div>
        </div>
      </div>
      <section className="content-container join-us-card-section">
        <div className=" info-card join-us-card">
          <div className="join-us-card-img">
            <img src={team} alt="Alnarp farm members" />
          </div>
          <div className="join-us-card-info">
            <h3>Member</h3>
            <p>{MemberText}</p>
            <Link className="btn " to="/memberships">
              I want to become a member
            </Link>
          </div>
        </div>
        <div className=" info-card join-us-card">
          <div className="join-us-card-img">
            <img src={volunteer} alt="Alnarp farm volunteer" />
          </div>
          <div className="join-us-card-info">
            <h3>Volunteer</h3>
            <p>{volunteerText}</p>
            {volunteerMailto ? (
              <a className="btn" href={volunteerMailto}>
                Sign up
              </a>
            ) : null}
          </div>
        </div>

        <div className=" info-card join-us-card">
          <div className="join-us-card-img">
            <img
              style={{ objectPosition: "top" }}
              src={internship}
              alt="Alnarp farm intern"
            />
          </div>
          <div className="join-us-card-info">
            <h3>Become an Intern</h3>
            <p>{InternText}</p>
            <Link className="btn" to="/education">
              Read more here
            </Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default JoinUsPage;
